import "@sourcewhale/shared/svelte-design-system/assets/css/design-system/_reset.scss";
import "@sourcewhale/shared/svelte-design-system/assets/css/design-system/_typography.scss";
import "../../css/pages/_dashboard.scss";

import { initializeGeneralUtils } from "@sourcewhale/shared/src/assets/js/src/general/utils";
import { initializeAttachments } from "@sourcewhale/shared/src/assets/js/src/sidebar/campaigns/attachments.js";
import { bindDashboard } from "../../../svelte/src/bindings/dashboard.js";
import { bindDialler } from "../../../svelte/src/bindings/dialler.js";
import { conditionallyBindModularization } from "../../../svelte/src/bindings/modularization";
import { initializeSidebar } from "../../../svelte/src/bindings/sidebar.js";
import { bindSystemBannerNotifications } from "../../../svelte/src/bindings/system-banner-notifications";
import { bindTestPanel } from "../../../svelte/src/bindings/test-panel-prod.js";
import { bindTodosModal } from "../../../svelte/src/bindings/todos-modal.js";
import { initializeContactUtils } from "../src/contact-utils.js";
import { initializeConfig } from "../src/general/config.js";
import { initializeCleartext } from "../src/general/elements/cleartext.js";
import { initializeTinymce } from "../src/general/elements/tinymce.js";
import { initializeTheme } from "../src/general/theme.js";
import { initializeTracking } from "../src/general/tracking.js";
import { initializeVisibilities } from "../src/general/visibilities.js";
import { initializeMarketingModal } from "../src/marketing/marketing.js";
import { initializeUploads } from "../src/uploads/uploads.js";
import { initializeWins } from "../src/wins/wins.js";

bindTestPanel();
bindSystemBannerNotifications();
initializeTheme();
initializeConfig();
initializeGeneralUtils();
initializeVisibilities();
initializeSidebar();
initializeWins();
initializeUploads();
initializeMarketingModal();

conditionallyBindModularization({
  licensesRequired: ["outreach"],
  success: () => {
    $("#toast-notifications").show();
    initializeTinymce();
    initializeContactUtils();
    bindDialler();
    bindDashboard();
    bindTodosModal();
    initializeAttachments();
    initializeCleartext();
    initializeTracking();
  },
});
